import { z } from 'zod';

export enum PermissionProject {
    ALL = 'project.all',
    ADMIN = 'project.admin',
    VIEW = 'project.view',
    EDIT = 'project.edit',
    DELETE = 'project.delete',
    COMPANY = 'project.company',
    COMMENT = 'project.comment',
}

export enum PermissionComponent {
    ALL = 'component.all',
    VIEW = 'component.view',
    EDIT = 'component.edit',
}

export enum PermissionTeam {
    USER = 'team.user',
    ADMIN = 'team.admin',
    OWNER = 'team.owner',
}

export enum PermissionDiagramGeneral {
    EDIT = 'general.edit',
    COMPANY = 'general.company',
    SHARE = 'general.share',
    DOWNLOAD = 'general.download',
    BOM = 'general.bom',
    REQUEST_SUPPORT = 'general.requestSupport',
    CREDITS = 'general.credits',
    AI = 'general.ai',
}

export enum PermissionDiagramElements {
    VIEW = 'elements.view',
    CREATE = 'elements.create',
    EDIT = 'elements.edit',
}

export enum PermissionDiagramImages {
    TEASER = 'images.teaser',
    VIEW = 'images.view',
    CREATE = 'images.create',
    EDIT = 'images.edit',
}

export enum PermissionDiagramGroups {
    VIEW = 'groups.view',
    CREATE = 'groups.create',
    EDIT = 'groups.edit',
}

export enum PermissionDigramComments {
    VIEW = 'comments.view',
    CREATE = 'comments.create',
    EDIT = 'comments.edit',
}

export enum PermissionDiagramFiles {
    VIEW = 'files.view',
    CREATE = 'files.create',
    EDIT = 'files.edit',
}

export enum PermissionDiagramSimulations {
    VIEW = 'simulations.view',
    CREATE = 'simulations.create',
    EDIT = 'simulations.edit',
}

export const PermissionSchemaProject = z.enum([
    PermissionProject.ALL,
    PermissionProject.ADMIN,
    PermissionProject.VIEW,
    PermissionProject.EDIT,
    PermissionProject.DELETE,
    PermissionProject.COMPANY,
    PermissionProject.COMMENT,
    PermissionComponent.ALL,
    PermissionComponent.VIEW,
    PermissionComponent.EDIT,
    PermissionTeam.OWNER,
    PermissionTeam.ADMIN,
    PermissionTeam.USER,
]);

export const PermissionSchemaDiagram = z.enum([
    PermissionDiagramGeneral.EDIT,
    PermissionDiagramGeneral.COMPANY,
    PermissionDiagramGeneral.SHARE,
    PermissionDiagramGeneral.DOWNLOAD,
    PermissionDiagramGeneral.BOM,
    PermissionDiagramGeneral.REQUEST_SUPPORT,
    PermissionDiagramGeneral.CREDITS,
    PermissionDiagramGeneral.AI,
    PermissionDiagramElements.VIEW,
    PermissionDiagramElements.CREATE,
    PermissionDiagramElements.EDIT,
    PermissionDiagramImages.TEASER,
    PermissionDiagramImages.VIEW,
    PermissionDiagramImages.CREATE,
    PermissionDiagramImages.EDIT,
    PermissionDiagramGroups.VIEW,
    PermissionDiagramGroups.CREATE,
    PermissionDiagramGroups.EDIT,
    PermissionDigramComments.VIEW,
    PermissionDigramComments.CREATE,
    PermissionDigramComments.EDIT,
    PermissionDiagramFiles.VIEW,
    PermissionDiagramFiles.CREATE,
    PermissionDiagramFiles.EDIT,
    PermissionDiagramSimulations.VIEW,
    PermissionDiagramSimulations.EDIT,
    PermissionDiagramSimulations.CREATE,
]);
